module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padre"
  }, [_vm._m(0), (_vm.closeComponentUsuario) ? _c('div', {
    staticClass: "message-body"
  }, [_c('strong', [_vm._v("No tiene pendientes")])]) : _vm._e(), _c('div', {
    staticClass: "display-flex fdc"
  }, [_c('div', {
    staticClass: "usuario display-flex fdr space-evenly flex-wrap"
  }, [(_vm.showCantidadMisDocumentosSinFirmar) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('mis-documentos-firmar')
      }
    }
  }, [_c('cantidad-mis-documentos-sin-firmar', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadMisDocumentosSinFirmar')
      }
    }
  })], 1) : _vm._e(), (_vm.showCantidadMisContratosSinFirmar) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('mis-contratos')
      }
    }
  }, [_c('cantidad-mis-contratos-sin-firmar', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadMisContratosSinFirmar')
      }
    }
  })], 1) : _vm._e(), (_vm.showCantidadMisBoletasSinVisualizar) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('boletas')
      }
    }
  }, [_c('cantidad-mis-boletas-sin-visualizar', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadMisBoletasSinVisualizar')
      }
    }
  })], 1) : _vm._e()])]), _c('div', {
    staticClass: "display-flex space-evenly flex-wrap"
  }, [_c('kpi-cumpleanos'), _c('kpi-cursos')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis pendientes")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72b607d1","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Dashboard_KPI_usuario.vue
// module id = 905
// module chunks = 0